import { render, staticRenderFns } from "./CustomersOverview.vue?vue&type=template&id=0e34ad48&scoped=true&"
import script from "./CustomersOverview.vue?vue&type=script&lang=js&"
export * from "./CustomersOverview.vue?vue&type=script&lang=js&"
import style0 from "./CustomersOverview.vue?vue&type=style&index=0&id=0e34ad48&scoped=true&lang=css&"
import style1 from "./CustomersOverview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34ad48",
  null
  
)

export default component.exports